import { useEffect, useState } from "react"
import ProposalService from "../../state/proposal/proposalService"

export const useProposalEmails = (proposalId: string, emailCount: number) => {
    const [emails, setEmails] = useState<string[]>([])

    useEffect(() => {
        if (!proposalId) {
            return
        }
        if (emailCount === 0 || emails.length === emailCount) {
            return
        }

        ProposalService.getEmails(proposalId).then((emails) => {
            setEmails(emails.data)
        })
    }, [proposalId, emailCount])
    return {
        emails: emails,
    }
}


// WEBPACK FOOTER //
// ./src/common/hooks/UseProposalEmails.ts